<oo-list-header (actionClicked)="toggleStatsPanel()" actionText="Stats">
</oo-list-header>
<oo-form-filler (afterSave)="afterSave()"
                [dataFetcher]="state.dataFetcher"
                [disabled]="state.isFormDisabled"
                [onSubmitCallback]="state.dataSaver">
</oo-form-filler>
